import React from 'react';

const componentName = "Support";

const Support = ({ toggleResourcesModal, toggleFeedbackModal, toggleAboutModal }) => {

    return (
        <>
            <div className="btn-group" id={`${componentName}-support`}>
                <button type="button" id={`${componentName}-supportBtn`} className="btn btn-link dropdown-toggle border-0" data-bs-toggle="dropdown" aria-expanded="false">
                    <i id={`${componentName}-supportIcon`} className="fa-regular fa-circle-question border-0 text-dark"></i>
                </button>
                <ul id={`${componentName}-supportDropdown`} className="dropdown-menu dropdown-menu-end">
                    <li>
                        <button className="dropdown-item" id={`${componentName}-resources`} eventKey="0" onClick={toggleResourcesModal}>
                            Resources
                        </button>
                    </li>
                    <li>
                        <button className="dropdown-item" id={`${componentName}-feedback`} eventKey="0" onClick={toggleFeedbackModal}>
                            Feedback
                        </button>
                    </li>
                    <li>
                        <button className="dropdown-item" id={`${componentName}-about`} eventKey="0" onClick={toggleAboutModal}>
                            About
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default Support;